/* eslint-disable no-unused-vars */
export const enum Tabs {
  OSI_INFO = 'OSI_INFO',
  ACCOUNTS = 'ACCOUNTS',
  SERVICE_COMPANIES = 'SERVICE_COMPANIES',
  TRUSTED_USERS = 'TRUSTED_USERS',
  ACCRUALS = 'ACCRUALS',
  SALDO = 'SALDO',
  DEBT_PERIODS = 'DEBT_PERIODS',
  SAMPLE_DOCUMENTS = 'SAMPLE_DOCUMENTS',
  OSI_INVOICES = 'OSI_INVOICES',
  OSI_PAST_INVOICES = 'OSI_PAST_INVOICES',
  OSI_QRPAGE = 'OSI_QRPAGE',
  OSI_OSV = 'OSI_OSV',
  FLAT_OSV = 'FLAT_OSV',
  ACCURALS_BY_ABONENT = 'ACCURALS_BY_ABONENT',
  PAYMENT_ORDERS = 'PAYMENT_ORDERS',
  OSI_PAYMENTS = 'OSI_PAYMENTS',
  OSI_FIXES = 'OSI_FIXES',
  OSI_SYSTEM_REPORTS = 'OSI_SYSTEM_REPORTS',
  ALL_ACCOUNT_REPORTS = 'ALL_ACCOUNT_REPORTS',
  YEAR_REPORTS = 'YEAR_REPORTS'
}
